import ModelState from './_util/model';

class WorkersState extends ModelState {
  sanitizeModelId(id) { return parseFloat(id); }

  get defaultQuery() {
    try {
      if (this.ctx.address.response && this.ctx.address.response.city && this.ctx.address.response.city.id) {
        return `cityContext=${this.ctx.address.response.city.id}&lastBooked=true&withPortfolio=true`;
      }

      return 'lastBooked=true&withPortfolio=true';
    } catch (e) {
      console.log('this.ctx.selection.city_id undefined');
    }

    return null;
  }

  get url() { return '/workers'; }
  get singular() { return 'worker'; }
  get plural() { return 'workers'; }
}

export default WorkersState;



// WEBPACK FOOTER //
// ./spa/state/workers.jsx